import { Outlet } from 'react-router-dom';
import Navbar from '../components/public/Navbar';

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-white flex flex-col relative w-full overflow-x-hidden">
      <Navbar />
      <main className="flex-grow w-full">
        <Outlet />
      </main>
    </div>
  );
}
